<template >
    <div class="container-fluid" v-if="student">

      <div class="card shadow mb-4" >
        <div class="card-header py-3">
          <div class="row">
            ,
            <h6 class="m-0 font-weight-bold text-primary">{{student.name}},  {{student.code}} оюутны мэдээлэл</h6>
          </div>
        </div>
        <div class="card-body">
          <p>Нэр: {{student.name}}</p>
          <p>Овог: {{student.lastname}}</p>
          <p >Оюутны код: {{student.code}}</p>
          <p >Регистрийн дугаар: {{student.register}}</p>
          <p >Имэйл: {{student.email}}</p>
          <p >Утасны дугаар: {{student.phone}}</p>
          <p v-if="student.school">Сургууль: {{student.school.id}}</p>
          <p v-if="student.department">Xөтөлбөрийн баг: {{student.department.id}}</p>
          <p v-if="student.program">Хөтөлбөр: {{student.program.id}}</p>
          <hr/>

          <h3 class="text-center">Оюутны төлбөрийн мэдээлэл</h3>

          <div class="card shadow my-4" v-for="(semester) in semesters" v-bind:key="semester.id">
            <div class="card-header py-3 row">
              <div class="col">
                <h4>{{semester.title}}</h4>
                <div v-if='semester.paymentHistory!=null'>
                  <p >Нийт: {{semester.paymentHistory.total}}</p>
                  <p v-if='semester!=null && semester.paymentHistory!=null && semester.paymentHistory!=null'>

                    <span v-if="semester.paymentHistory.paid==true" class="badge badge-pill badge-success">төлсөн</span>
                    <span v-else class="badge badge-pill badge-danger">төлөөгүй</span>
                  </p>
                </div>
              </div>
              <div v-if='semester.default==true' class="col-auto"> 
                <div v-if="semester.paymentHistory.paid!=true" class="btn btn-primary" @click="setPaidForStudent(true,semester)">Төлбөр төлсөн</div>
                <div v-else class="btn btn-primary" @click="setPaidForStudent(false,semester)">Төлбөр төлөөгүй</div>
              </div>
              <div v-if='semester.default==true' class="col-auto"> <div class="btn btn-success" @click="askPayment(semester)">Төлбөр нэмэх</div></div>

            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" v-if="semester.paymentHistory!=null && semester.paymentHistory.paymentHistory.length>0">
                  <thead>
                    <tr>
                      <th>№</th>
                      <th>Огноо</th>
                      <th>Дүн</th>
                      <th>Үйлдэл</th>
                    </tr>
                  </thead>

                  <tbody>
					          <tr v-for="(payment, index) in semester.paymentHistory.paymentHistory" v-bind:key="payment.id">
                      <td>{{index+1}}</td>
                      <td>{{payment.date | formatDate}}</td>
                      <td>{{payment.value}}</td>
                      <!-- <td><span v-if="lesson.createdAt!=null">{{lesson.createdAt | formatDate}}</span></td> -->
                      <td>
                        <button class="btn btn-warning" @click="edit(lesson)">засах</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="alert alert-success text-center">Одоогоор төлбөрийн мэдээлэл байхгүй байна.</div>
              </div>
            </div>
          </div>
            
        </div>

      </div>


      <!-- Modal -->
      <div class="modal fade" id="paymentModal" tabindex="-1" role="dialog" aria-labelledby="paymentModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="qaModalLabel">Төлбөрийн мэдээлэл нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                  <input v-model.number="value" type="number" class="form-control" placeholder="Төлсөн дүн">
                </div>
                <hr>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click="savePayment" type="button" class="btn btn-primary btn-user btn-block" >Save</button>
            </div>
          </div>
        </div>
      </div>

    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: "StudentDetail",
    data() {
        return {
            student: null,
            semesters:[],
            value: null,
            selectedSemester:null
        };
    },
    methods: {  
      _getStudent(){
        fb.db.collection("semester").get().then(semestersSnapshot=>{
          semestersSnapshot.forEach(semesterDoc=> {
              let object=semesterDoc.data()
              object.id = semesterDoc.id;
              object.paymentHistory={paid:false, paymentHistory:[]};

              fb.db.collection("students").doc(this.studentId).collection('paymentHistory').doc(semesterDoc.id)
                .onSnapshot(payment=> {
                object.paymentHistory=payment.data();

          
              });
              this.semesters.push(object);
          });
        });

          fb.db.collection("students").doc(this.studentId).get().then(doc=> {
              let student=doc.data();
              student.id=doc.id;
              this.student=student;
          });


      },
      askPayment(semester){
        this.selectedSemester=semester;
        $('#paymentModal').modal('show');
      },
      savePayment(){
        var _this=this;
        if(this.selectedSemester!=null && this.selectedSemester!='' && this.value!=null && this.value!=0){
          var tmp={
            'date': new Date(),
            'value':this.value
          }
          
          fb.db.collection("students").doc(this.studentId).collection('paymentHistory').doc(this.selectedSemester.id).get().then(value=>{
            if(value.exists)
              value.ref.update({'total': fb.firestore.FieldValue.increment(tmp.value),'paymentHistory': fb.firestore.FieldValue.arrayUnion(tmp)});
            else
              value.ref.set({'total': tmp.value, 'paymentHistory': fb.firestore.FieldValue.arrayUnion(tmp)});
            
          });
          

          this.value=null;
          this.selectedSemester=null;
           $('#paymentModal').modal('hide');
        }
        else{
          alert("Та төлбөрийн мэдээллийг гүйцэд оруулна уу");
        }
      },
      setPaidForStudent( value, semester){
        this.setProperty("paid", fb.db.doc("students/"+this.studentId+"/paymentHistory/"+semester.id), value);
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        studentId: { 
            required: true,
        }
    },
    created() {
      if(this.studentId!=null && this.studentId!='')
        this._getStudent();
          
    },
    filters: {
        formatDateFromNow(val) {
            if (!val) { return '-' }
            let date = val.toDate()
            return moment(date).fromNow()
        },
        formatDate(val) {
            if (!val) { return '-' }
            let date = val.toDate()
            return moment(date).format('MM/DD/YYYY HH:mm');
        },
        trimLength(val) {
            if (val.length < 200) { return val }
            return `${val.substring(0, 200)}...`
        }
    }
  
};
</script>

